import { render, staticRenderFns } from "./FieldGeneralTab.vue?vue&type=template&id=3cde4a38"
import script from "./FieldGeneralTab.vue?vue&type=script&lang=js"
export * from "./FieldGeneralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports